import { Reveal } from "../components/Reveal";

const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative scroll-mt-24 bg-ivory px-6 py-36 sm:px-10 sm:py-52"
    >
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <span className="text-[0.7rem] uppercase tracking-[0.28em] text-gold">
            004 — Manifesto
          </span>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-10 font-serif text-[2.6rem] font-light leading-[1.02] tracking-tight text-ink sm:text-6xl lg:text-[5.5rem] lg:leading-[0.98]">
            Some ideas deserve to exist simply because they make us{" "}
            <span className="italic text-oxblood">feel something.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-12 max-w-md font-serif text-2xl italic text-ink-soft">
            We Cook Art was built for those ideas.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Manifesto;
